import { useSelector } from 'react-redux'

import { selectArrivalStep, selectDepartureStep } from './steps/steps.selectors'

const useItineraryRouteError = error => {
  const departureStep = useSelector(selectDepartureStep)
  const arrivalStep = useSelector(selectArrivalStep)
  const isSameStep = departureStep.label === arrivalStep.label
  const sameStepError = {
    name: 'itinerary.same-step.error'
  }

  return isSameStep ? sameStepError : error
}

export default useItineraryRouteError
